var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-n6"},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","lg":"12","xl":"8"}},[_c('v-card',[_c('v-card-title',[_vm._v("Packaging Rules")]),_c('v-card-text',[_vm._v("Text goes here")]),_c('v-card-actions',[_vm._v("action here")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }